import './App.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import SignIn from './screens/signIn';
import ForgotPassword from './screens/forgotPassword';
import LandingPage from './screens/landingPage';
import Profile from './screens/profile';
import CorporateProfile from './screens/CorporateProfile/corporateProfile'
import ApplicationStatus from './screens/applicationStatus'
import ContactUs from './screens/contactUs';
import PrintDocuments from './screens/printDocuments';
import ProtectedRoute from './hooks/protectedRoute';
import ApplicationForm from './screens/Examination-NYSC/applicationForm';
import ResetPassword from './screens/resetPassword';
import SignUp from './screens/signUp';
import Notification from './screens/notification';
import ChangePassword from './screens/changePassword';
import Welcome from './screens/welcome'
import PaymentReminder from './screens/paymentReminder'
import PractitionerApplicationForm from "./screens/Practitioner/applicationForm";
import MilitaryApplicationForm from "./screens/Military/applicationForm"
import MilitaryBApplicationForm from "./screens/MilitaryB/applicationForm"
import ExecutiveApplicationForm from "./screens/Executive/applicationForm"
import { RootState } from "./providers/store";
import { useSelector } from "react-redux";
import AcademicApplicationForm from './screens/Academic/applicationForm';
import ApplicationFormSuccess from './screens/applicationFormSuccess';
import CorporateApplicationForm from "./screens/Corporate/applicationForm"
import ErrorPage from './screens/ErrorPage/errorPage'
import TrainingPayment from './screens/trainingPayment';
import InductionPayment from './screens/inductionPayment';
import { academicRoute, academicRouteB, corporateRoute, examinationRoute, executiveRoute, militaryRoute, militaryRouteB, practitionerRoute } from './utils/allRoute';
import NyscPreviewPage from './screens/PreviewPage/nyscPreviewPage';
import PractitionerPreviewPage from './screens/PreviewPage/practitionerPreviewPage';
import CorporatePreviewPage from './screens/PreviewPage/corporatePreviewPage';
import Requirements from './screens/Requirements/main'
import AcademicSignUp from './screens/Academic/signupPage';
import AcademicBApplicationForm from './screens/AcademicB/applicationForm';
import MilitarySignUp from "./screens/Military/signUpPage"

function App() {

  const sessionDetails = useSelector((state: RootState) => state?.sessionDetails?.sessionDetails);

 
  return (
  <BrowserRouter>
    <Routes>
      <Route path='/' element={<LandingPage />} />
      <Route path="/login" element={<SignIn />} />
      <Route path='/signUp' element={<SignUp />} />
      <Route path='/sign-up' element={<AcademicSignUp />} />
      <Route path='/military/sign-up' element={<MilitarySignUp />}/>

      <Route path='/registration/requirement' element={<Requirements/>} />
      <Route path='/notification' element={<ProtectedRoute routeId={parseInt(sessionDetails?.RouteId)}><Notification/></ProtectedRoute> }/>
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/resetpassword' element={<ResetPassword />} />
      <Route path='/change-password'element={<ProtectedRoute routeId={parseInt(sessionDetails?.RouteId)}><ChangePassword /></ProtectedRoute>}/>
      <Route path='/application-form-success'element={<ProtectedRoute routeId={parseInt(sessionDetails?.RouteId)}><ApplicationFormSuccess /></ProtectedRoute>}/>
      {
        sessionDetails?.ActionName === "Training" &&
        <Route path='/training-payment' element={<ProtectedRoute routeId={parseInt(sessionDetails?.RouteId)}><TrainingPayment /></ProtectedRoute>} />
      }
      {
        sessionDetails?.ActionName === "Induction" &&
        <Route path='/induction-payment'element={<ProtectedRoute routeId={parseInt(sessionDetails?.RouteId)}><InductionPayment /></ProtectedRoute>}/>
      }
       
        {
        sessionDetails?.PaymentStatus === "Open" && 
        <Route path='/pending-payment-reminder' element={<ProtectedRoute routeId={parseInt(sessionDetails?.RouteId)}><PaymentReminder /></ProtectedRoute>}/>
       }
   
   
      {/* NYSC/ Examination */}
      <Route path='/examination-NYSC/welcome' element={<ProtectedRoute routeId={parseInt(examinationRoute)}><Welcome /></ProtectedRoute>}/>
      <Route path='/examination-NYSC/profile' element= {<ProtectedRoute routeId={parseInt(examinationRoute)}><Profile /></ProtectedRoute>}/>
      { !sessionDetails?.HasPaidAcceptanceFee &&
      <Route path = '/examination-NYSC/application-status' element = {<ProtectedRoute  routeId={parseInt(examinationRoute)}><ApplicationStatus/></ProtectedRoute>}/>
      }
       { !sessionDetails?.HasPaidAcceptanceFee &&
      <Route path='/examination-NYSC/application-form' element={<ProtectedRoute routeId={parseInt(examinationRoute)}><ApplicationForm/></ProtectedRoute>} />
      }
      { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/examination-NYSC/preview-page' element={<ProtectedRoute routeId={parseInt(examinationRoute)}><NyscPreviewPage/></ProtectedRoute>} />
      }
      <Route path='/examination-NYSC/contact-us' element={<ProtectedRoute routeId={parseInt(examinationRoute)}><ContactUs/></ProtectedRoute>} />
      <Route path='/examination-NYSC/print-documents' element={<ProtectedRoute routeId={parseInt(examinationRoute)}><PrintDocuments/></ProtectedRoute>} />

      {/* Practitioner */}
      <Route path='/practitioner/welcome'element={<ProtectedRoute routeId={parseInt(practitionerRoute)}><Welcome /></ProtectedRoute>}/>
      <Route path='/practitioner/profile' element= {<ProtectedRoute routeId={ parseInt(practitionerRoute)}><Profile /></ProtectedRoute>}/>
      {
        !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/practitioner/application-status' element={<ProtectedRoute routeId={parseInt(practitionerRoute)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {
        !sessionDetails?.HasPaidAcceptanceFee &&    
          <Route path='/practitioner/application-form' element={<ProtectedRoute routeId={parseInt(practitionerRoute)}><PractitionerApplicationForm/></ProtectedRoute>} />
      }
      { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/practitioner/preview-page' element={<ProtectedRoute routeId={parseInt(practitionerRoute)}><PractitionerPreviewPage/></ProtectedRoute>} />
      }
      <Route path='/practitioner/contact-us' element={<ProtectedRoute routeId={parseInt(practitionerRoute)}><ContactUs/></ProtectedRoute>} />
      
      <Route path='/practitioner/print-documents' element={<ProtectedRoute routeId={parseInt(practitionerRoute)}><PrintDocuments/></ProtectedRoute>} />
      
     

      <Route path='*' element={<ErrorPage />} />
      



      {/* EXECUTIVE */}
      <Route path='/executive/welcome'element={<ProtectedRoute routeId={parseInt(executiveRoute)}><Welcome /></ProtectedRoute>}/>
      <Route path='/executive/profile' element= {<ProtectedRoute routeId={parseInt(executiveRoute)}><Profile /></ProtectedRoute>}/>
      {
         !sessionDetails?.HasPaidAcceptanceFee && 
         <Route path='/executive/application-status' element={<ProtectedRoute routeId={parseInt(executiveRoute)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {
         !sessionDetails?.HasPaidAcceptanceFee && 
         <Route path='/executive/application-form' element={<ProtectedRoute routeId={parseInt(executiveRoute)}><ExecutiveApplicationForm/></ProtectedRoute>} />
      }
       { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/executive/preview-page' element={<ProtectedRoute routeId={parseInt(executiveRoute)}><PractitionerPreviewPage/></ProtectedRoute>} />
      }
      
      <Route path='/executive/contact-us' element={<ProtectedRoute routeId={parseInt(executiveRoute)}><ContactUs/></ProtectedRoute>} />
      <Route path='/executive/print-documents' element={<ProtectedRoute routeId={parseInt(executiveRoute)}><PrintDocuments/></ProtectedRoute>} />

      {/* ACADEMIC */}
      {
           !sessionDetails?.HasPaidAcceptanceFee && 
           <Route path='/academic/application-status' element={<ProtectedRoute routeId={parseInt(academicRoute)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {   !sessionDetails?.HasPaidAcceptanceFee && 
            <Route path='/academic/application-form' element={<ProtectedRoute routeId={parseInt(academicRoute)}><AcademicApplicationForm/></ProtectedRoute>} />
      }
      { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/academic/preview-page' element={<ProtectedRoute routeId={parseInt(academicRoute)}><PractitionerPreviewPage/></ProtectedRoute>} />
      }
      <Route path='/academic/welcome'element={<ProtectedRoute routeId={parseInt(academicRoute)}><Welcome /></ProtectedRoute>}/>
      <Route path='/academic/profile' element= {<ProtectedRoute routeId={parseInt(academicRoute)}><Profile /></ProtectedRoute>}/>
      <Route path='/academic/contact-us' element={<ProtectedRoute routeId={parseInt(academicRoute)}><ContactUs/></ProtectedRoute>} />
      <Route path='/academic/print-documents' element={<ProtectedRoute routeId={parseInt(academicRoute)}><PrintDocuments/></ProtectedRoute>} />

    
    
      {/* ACADEMIC ROUTE B */}
      {
           !sessionDetails?.HasPaidAcceptanceFee && 
           <Route path='/application-status/academic' element={<ProtectedRoute routeId={parseInt(academicRouteB)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {   !sessionDetails?.HasPaidAcceptanceFee && 
            <Route path='/application-form/academic' element={<ProtectedRoute routeId={parseInt(academicRouteB)}><AcademicBApplicationForm/></ProtectedRoute>} />
      }
      { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/preview-page/academic' element={<ProtectedRoute routeId={parseInt(academicRouteB)}><PractitionerPreviewPage/></ProtectedRoute>} />
      }
      
      <Route path='/welcome/academic'element={<ProtectedRoute routeId={parseInt(academicRouteB)}><Welcome /></ProtectedRoute>}/>
      <Route path='/profile/academic' element= {<ProtectedRoute routeId={parseInt(academicRouteB)}><Profile /></ProtectedRoute>}/>
      <Route path='/contact-us/academic' element={<ProtectedRoute routeId={parseInt(academicRouteB)}><ContactUs/></ProtectedRoute>} />
      <Route path='/print-documents/academic' element={<ProtectedRoute routeId={parseInt(academicRouteB)}><PrintDocuments/></ProtectedRoute>} />
      
      {/* MILITARY */}
      {
        !sessionDetails?.HasPaidAcceptanceFee && 
        <Route path='/military/application-status' element={<ProtectedRoute routeId={parseInt(militaryRoute)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {
        !sessionDetails?.HasPaidAcceptanceFee && 
        <Route path='/military/application-form' element={<ProtectedRoute routeId={parseInt(militaryRoute)}><MilitaryApplicationForm/></ProtectedRoute>} />
      }
      { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/military/preview-page' element={<ProtectedRoute routeId={parseInt(militaryRoute)}><PractitionerPreviewPage/></ProtectedRoute>} />
      }
      <Route path='/military/welcome'element={<ProtectedRoute routeId={parseInt(militaryRoute)}><Welcome /></ProtectedRoute>}/>
      <Route path='/military/profile' element= {<ProtectedRoute routeId={parseInt(militaryRoute)}><Profile /></ProtectedRoute>}/>
      <Route path='/military/contact-us' element={<ProtectedRoute routeId={parseInt(militaryRoute)}><ContactUs/></ProtectedRoute>} />
      <Route path='/military/print-documents' element={<ProtectedRoute routeId={parseInt(militaryRoute)}><PrintDocuments/></ProtectedRoute>} />

       {/* MILITARYB */}
       {
        !sessionDetails?.HasPaidAcceptanceFee && 
        <Route path='/application-status/military' element={<ProtectedRoute routeId={parseInt(militaryRouteB)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {
        !sessionDetails?.HasPaidAcceptanceFee && 
        <Route path='/application-form/military' element={<ProtectedRoute routeId={parseInt(militaryRouteB)}><MilitaryBApplicationForm/></ProtectedRoute>} />
      }
      { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/preview-page/military' element={<ProtectedRoute routeId={parseInt(militaryRouteB)}><PractitionerPreviewPage/></ProtectedRoute>} />
      }
      <Route path='/welcome/military'element={<ProtectedRoute routeId={parseInt(militaryRouteB)}><Welcome /></ProtectedRoute>}/>
      <Route path='/profile/military' element= {<ProtectedRoute routeId={parseInt(militaryRouteB)}><Profile /></ProtectedRoute>}/>
      <Route path='/contact-us/military' element={<ProtectedRoute routeId={parseInt(militaryRouteB)}><ContactUs/></ProtectedRoute>} />
      <Route path='/print-documents/military' element={<ProtectedRoute routeId={parseInt(militaryRouteB)}><PrintDocuments/></ProtectedRoute>} />



      {/* Corporate */}
      {
          !sessionDetails?.HasPaidAcceptanceFee && 
          <Route path='/corporate/application-status' element={<ProtectedRoute routeId={parseInt(corporateRoute)}><ApplicationStatus/></ProtectedRoute>} />
      }
      {
          !sessionDetails?.HasPaidAcceptanceFee && 
          <Route path='/corporate/application-form' element={<ProtectedRoute routeId={parseInt(corporateRoute)}><CorporateApplicationForm/></ProtectedRoute>} />
      }
       { !sessionDetails?.HasPaidAcceptanceFee &&
        <Route path='/corporate/preview-page' element={<ProtectedRoute routeId={parseInt(corporateRoute)}><CorporatePreviewPage/></ProtectedRoute>} />
      }
      <Route path='/corporate/welcome'element={<ProtectedRoute routeId={parseInt(corporateRoute)}><Welcome /></ProtectedRoute>}/>
      <Route path='/corporate/profile' element= {<ProtectedRoute routeId={parseInt(corporateRoute)}><CorporateProfile /></ProtectedRoute>}/>
      <Route path='/corporate/contact-us' element={<ProtectedRoute routeId={parseInt(corporateRoute)}><ContactUs/></ProtectedRoute>} />
      <Route path='/corporate/print-documents' element={<ProtectedRoute routeId={parseInt(corporateRoute)}><PrintDocuments/></ProtectedRoute>} />

    </Routes>
  </BrowserRouter>
  );
}

export default App;
